import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { Gate } from '../../../global/contexts/auth/auth';
import { useStandard, useVersions } from '../contexts/standards';
import StandardEditor from '../forms/editor';
import { standardFields, versionFields } from '../utils/fields';

export default function StandardDetail({ id }) {
    const standard = useStandard(id);
    const versions = useVersions(id);
    const [editing, setEditing] = useState(null);
    const navigate = useNavigate();
    if (standard.isPending) return <p>Cargando estándar...</p>;
    if (standard.error) return <p role="alert">{standard.error.message}</p>;
    const item = standard.data;
    return <section className="standards">
        <Link to="/admin/standards">← Estándares</Link>
        <header className="standards__header"><div><h1>{item.name}</h1><p>{item.track} · {item.code} · ID {item.id}</p></div></header>
        <p>{item.description}</p>
        {!editing && <Gate domain="standards:write"><div className="standards__actions">
            <button onClick={() => setEditing('metadata')}>Editar datos</button>
            <button className="standards__primary" onClick={() => setEditing('version')}>Nueva versión</button>
        </div></Gate>}
        {editing === 'metadata' && <Gate domain="standards:write"><StandardEditor title="Editar estándar"
            fields={standardFields.filter(f => !['code', 'track'].includes(f.name))} initial={item} action="editStandard" id={item.id}
            onSaved={() => setEditing(null)} onCancel={() => setEditing(null)} /></Gate>}
        {editing === 'version' && <Gate domain="standards:write"><StandardEditor title="Nueva versión" fields={versionFields}
            initial={{ number: '', summary: '', content: '' }} action="createVersion" id={item.id}
            onSaved={saved => navigate(`/admin/standards/${item.id}/versions/${saved.id}`)} onCancel={() => setEditing(null)} /></Gate>}
        <h2>Versiones</h2>
        {versions.isPending && <p>Cargando versiones...</p>}
        {versions.error && <p role="alert">{versions.error.message}</p>}
        {versions.isSuccess && !versions.data.length && <p>Aún no tiene versiones. Crea un borrador para escribir sus reglas.</p>}
        <div className="standards__grid">{(versions.data ?? []).map(version => <Link key={version.id} className="standards__card standards__link" to={`/admin/standards/${item.id}/versions/${version.id}`}>
            <span className="standards__badge">{version.version_state === 'published' ? 'Publicada' : 'Borrador'}</span>
            <h3>{version.number}</h3><p>{version.summary}</p><small>Versión ID {version.id}</small>
        </Link>)}</div>
        <p>Publica las versiones cuando sus reglas estén revisadas. La asociación al repositorio se hace desde su ficha.</p>
    </section>;
}
